export default {
  title: 'Evaluaciones Diagnósticas',
  all_diagnostics: 'Todas las evaluaciones',
  filter_by_grade: 'Filtrar por grado',
  filter_by_country: 'Filtrar por país',
  select_country: 'Selecciona un país',
  select_grade: 'Selecciona un grado',
  all_grades: 'Todos los grados',
  grade: 'Grado',
  level: 'Nivel',
  name: 'Nombre',
  has_variant: 'Tiene variante',
  no_variant: 'Sin variante',
  edit: 'Editar',
  back_to_list: 'Volver a Diagnósticos',
  questions: 'Preguntas',
  question: 'Pregunta',
  question_number: 'Pregunta #',
  skill: 'Habilidad',
  correct_answer: 'Respuesta correcta',
  variant: 'Variante',
  actions: 'Acciones',
  evaluation: 'Evaluación',
  country: 'País',
  edit_question: 'Editar Pregunta',
  original_reference: 'Original (referencia)',
  adapted_question: 'Pregunta adaptada',
  alternatives: 'Alternativas',
  alternative: 'Alternativa',
  answer: 'Respuesta',
  correct: 'correcta',
  cancel: 'Cancelar',
  save_changes: 'Guardar cambios',
  saving: 'Guardando...',
  save_success: 'Variante guardada correctamente',
  save_error: 'Error al guardar la variante',
  field_required: 'Este campo es requerido',
  no_permission: 'No tienes permiso para acceder a esta funcionalidad',
  all_levels: 'Todos los niveles',
  all_variants: 'Todos',
  search_placeholder: 'Buscar por ID o nombre',
  search: 'Buscar',
  clear_filters: 'Limpiar filtros',
  levels: {
    INITIAL: 'Diagnóstico',
    INTERMEDIATE: 'Intermedia',
    ADVANCED: 'Cierre',
  },
  countries: {
    USA: 'Estados Unidos',
    PER: 'Perú',
  },
  no_diagnostics_found: 'No se encontraron evaluaciones',
  loading_diagnostics: 'Cargando evaluaciones...',
  loading_questions: 'Cargando preguntas...',
  no_questions_found: 'No se encontraron preguntas',
};
